export const GET_DANH_SACH_KHO = 'GET_DANH_SACH_KHO';
export const GET_DANH_SACH_KHO_DONE = 'GET_DANH_SACH_KHO_DONE';

export const CREATE_KHO_HANG = 'CREATE_KHO_HANG';
export const UPDATE_STATUS_KHO_HANG = 'UPDATE_STATUS_KHO_HANG';
export const UPDATE_DEFAULT_KHO_HANG = 'UPDATE_DEFAULT_KHO_HANG';
export const UPDATE_KHO_HANG = 'UPDATE_KHO_HANG';